import React from 'react';
import './HelperWindows.css';

function EvaluationResults({ evaluation, onNewSession, onEndSession }) {
  if (!evaluation) return null;

  const { scores, overall_score, strengths, improvements, examples } = evaluation;

  const getScoreColor = (score) => {
    if (score >= 8) return '#4caf50';
    if (score >= 6) return '#ff9800';
    return '#f44336';
  };

  const getScoreLabel = (score) => {
    if (score >= 8) return 'Excellent';
    if (score >= 6) return 'Good';
    if (score >= 4) return 'Needs Work';
    return 'Poor';
  };

  return (
    <div className="evaluation-results">
      <div className="evaluation-header">
        <h1>📊 Evaluation Report</h1>
        <div className="overall-score" style={{ borderColor: getScoreColor(overall_score) }}>
          <div className="score-number">{overall_score.toFixed(1)}</div>
          <div className="score-label">{getScoreLabel(overall_score)}</div>
        </div>
      </div>

      <div className="evaluation-section">
        <h2>Performance Scores</h2>
        <div className="scores-grid">
          {Object.entries(scores).map(([category, score]) => (
            <div key={category} className="score-item">
              <div className="score-category">
                {category.split('_').map(word => 
                  word.charAt(0).toUpperCase() + word.slice(1)
                ).join(' ')}
              </div>
              <div className="score-bar-container">
                <div 
                  className="score-bar" 
                  style={{ 
                    width: `${(score / 10) * 100}%`,
                    backgroundColor: getScoreColor(score)
                  }}
                />
              </div>
              <div className="score-value">{score}/10</div>
            </div>
          ))}
        </div>
      </div>

      {strengths && strengths.length > 0 && (
        <div className="evaluation-section">
          <h2>✅ Strengths</h2>
          <ul className="feedback-list strengths-list">
            {strengths.map((strength, idx) => (
              <li key={idx}>{strength}</li>
            ))}
          </ul>
        </div>
      )}

      {improvements && improvements.length > 0 && (
        <div className="evaluation-section">
          <h2>💡 Areas for Improvement</h2>
          <ul className="feedback-list improvements-list">
            {improvements.map((improvement, idx) => (
              <li key={idx}>{improvement}</li>
            ))}
          </ul>
        </div>
      )}

      {examples && (examples.good?.length > 0 || examples.improve?.length > 0) && (
        <div className="evaluation-section">
          <h2>📝 Examples from Your Conversation</h2>
          {examples.good && examples.good.length > 0 && (
            <div className="examples-subsection">
              <h3>Good Techniques:</h3>
              <ul className="examples-list good-examples">
                {examples.good.map((example, idx) => (
                  <li key={idx}>"{example}"</li>
                ))}
              </ul>
            </div>
          )}
          {examples.improve && examples.improve.length > 0 && (
            <div className="examples-subsection">
              <h3>Could Be Improved:</h3>
              <ul className="examples-list improve-examples">
                {examples.improve.map((example, idx) => (
                  <li key={idx}>"{example}"</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}

      <div className="evaluation-actions">
        <button onClick={onNewSession} className="action-btn primary-btn">
          🔄 Start New Evaluation
        </button>
        <button onClick={onEndSession} className="action-btn secondary-btn">
          🏠 Back to Dashboard
        </button>
      </div>
    </div>
  );
}

export default EvaluationResults;
